import { map } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { RouterAction } from '@cbridge-packages/routing';
import { NodeParam } from '../_helpers/nodeSearchParam';
import { SymbolPoolAction } from '../symbolPool.action';

export const clearSelectNodeEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(SymbolPoolAction.clearSelect),
  map(() => {
    return RouterAction.removeParam(NodeParam.name);
  }),
);
